import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function VoorBedrijvenBedankt() {
  return (
    <div className="py-24" data-testid="b2b-thanks-page">
      <div className="max-w-2xl mx-auto px-6 text-center">
        <div className="h-20 w-20 rounded-full bg-[#10B981]/10 flex items-center justify-center mx-auto">
          <CheckCircle2 className="h-10 w-10 text-[#10B981]" />
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-ink mt-6 tracking-tight">
          Bedankt voor je aanmelding!
        </h1>
        <p className="text-ink-soft mt-5 leading-relaxed">
          We hebben je gegevens ontvangen en sturen je binnen <b>2 werkdagen</b> een bevestiging per e-mail. Daarin staat ook de eerste betaalstap voor de €29/maand partnerbijdrage.
        </p>
        <p className="text-ink-soft mt-3 text-sm">
          Heb je in tussentijd vragen? Mail naar <a href="mailto:info@checkexpert.be" className="text-[#002FA7] font-semibold">info@checkexpert.be</a>.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#002FA7] hover:bg-[#0033B5] text-white font-semibold"
          >
            Terug naar home
          </Link>
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white border border-border text-ink font-semibold hover:border-ink-soft"
          >
            Lees onze blog
          </Link>
        </div>
      </div>
    </div>
  );
}
